import styled from "styled-components";
import { Link } from "react-router-dom";

export const Nav = styled.div`
    padding: 0 2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
    border-radius: 0 0 20px 20px;
    height: 80px;
    font-size: 1.2rem;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
`;

export const MenuLink = styled(Link)`
    cursor: pointer;
    text-align: center;
    text-decoration: none;
    color: #ecf0f1;
    transition: all 0.3s ease;
    font-size: 1.1rem;
    font-family: "Poppins", sans-serif;
    font-weight: 500;
    padding: 0.5rem 1rem;
    border-radius: 8px;

    &:hover {
        color: #667eea;
        background: rgba(102, 126, 234, 0.1);
        transform: translateY(-2px);
    }

    @media (max-width: 768px) {
        padding: 1rem;
        margin: 0.5rem 0;
        border-radius: 10px;
        width: 90%;
        background: rgba(255, 255, 255, 0.1);
    }
`;

export const Menu = styled.div`
    background: rgba(255, 255, 255, 0.05);
    padding: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 1;
    border-radius: 15px;
    backdrop-filter: blur(10px);

    @media (max-width: 768px) {
        overflow: hidden;
        flex-direction: column;
        width: 100%;
        display: ${({ osman }) => (osman ? "flex" : "none")};
        background: rgba(44, 62, 80, 0.95);
        border-radius: 15px;
        margin-top: 1rem;
    }

    a {
        padding: 0 1.5rem;
        cursor: pointer;
        text-align: center;
        text-decoration: none;
        color: #ecf0f1;
        transition: all 0.3s ease;
        font-size: 1.1rem;
        font-family: "Poppins", sans-serif;
        font-weight: 500;

        &:hover {
            color: #667eea;
            transform: translateY(-2px);
        }

        @media (max-width: 768px) {
            padding: 1rem;
            margin: 0.5rem 0;
            border-radius: 10px;
            width: 90%;
            background: rgba(255, 255, 255, 0.1);
        }
    }
`;

export const Logo = styled(MenuLink)`
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 0.8rem 2rem;
    color: white;
    font-weight: 700;
    font-size: 1.3rem;
    border-radius: 15px;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
        background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
    }

    i {
        padding: 0 1rem;
    }
`;

export const Hamburger = styled.div`
    display: none;
    cursor: pointer;
    color: white;
    font-size: 1.5rem;
    padding: 0.5rem;
    border-radius: 8px;
    transition: all 0.3s ease;

    &:hover {
        background: rgba(255, 255, 255, 0.1);
    }

    @media (max-width: 768px) {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;
